window.onVariantChanged = function(currVariant) {
  var datahascoloronchange = $(".product-section").find(".main").attr("data-producthascolor");
  window.currVariant = currVariant;
  let altTagToMatch = "color_" + window.currVariant['option' + window.colorOptionPosition];
  altTagToMatch = altTagToMatch.toLowerCase().replaceAll(" ", "_");
  if(datahascoloronchange == "true"){
  $('.slider-for').slick('slickUnfilter');
  $('.slider-for').slick('slickFilter', `[data-alt="${ altTagToMatch }"]`);
  $('.slider-for').slick('refresh');
  
  $('.slider-nav').slick('slickUnfilter');
  $('.slider-nav').slick('slickFilter', `[data-alt="${ altTagToMatch }"]`);
  $('.slider-nav').slick('refresh');
  }
}
$(document).ready(function() {
  var datahascolor = $(".product-section").find(".main").attr("data-producthascolor");
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          vertical: false,
          verticalSwiping: false,
        }
      }
    ]
  });
  if(datahascolor == "true"){
  console.log("inif",datahascolor)
  $('.slider-for').slick('slickUnfilter');
  $('.slider-for').slick('slickFilter', `[data-alt="${ window.firstLoadedVariantColor }"]`);
  $('.slider-for').slick('refresh');
  
  $('.slider-nav').slick('slickUnfilter');
  $('.slider-nav').slick('slickFilter', `[data-alt="${ window.firstLoadedVariantColor }"]`);
  $('.slider-nav').slick('refresh');
  }


  $(window).on('resize load orientationChange', function() {
    if ($(window).width() <= 768) {
      var $header_overlay_height = $('.header-wrapper--overlay').height(),
          $header_outer_height = $('div[data-section-type=header-section]');
          $header_outer_height.css('height', $header_overlay_height);
        // console.log($header_overlay_height);
        // console.log($header_outer_height);
      } else {
        
      }
  }).resize();
  
});

document.addEventListener('DOMContentLoaded', function() {
  // Function to animate numbers
  function animateValue(element, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      element.innerText = (progress * (end - start) + start).toFixed(2);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  // Function to calculate and update environmental impact
  function updateEnvironmentalImpact(cartItems) {
    var totalWaterCleaned = 0;
    var totalCo2Captured = 0;

    if (cartItems.length > 0) {
      cartItems.forEach(function(item) {
        var variantId = item.variant_id;
        var quantity = item.quantity;

        var productMetafields = window.productMetafields ? window.productMetafields[variantId] || {} : {};

        var waterCleaned = productMetafields['water_cleaned'] || 0;
        var co2Captured = productMetafields['co2_captured'] || 0;

        totalWaterCleaned += waterCleaned * quantity;
        totalCo2Captured += co2Captured * quantity;
        plasticRemoved = 1;
      });

      var drawerHeader = document.querySelector('.qsc2-drawer-footer');

      if (drawerHeader) {
        var impactInfo = document.createElement('div');
        impactInfo.classList.add('impact-info');
        impactInfo.innerHTML = `
          <h3>YOUR IMPACT</h3>
          <div class="impact-wrapper">
            <div class="impact-content">
              <svg style="width:50px; height:50px;" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" viewBox="0 0 400.000000 400.000000" height="400.000000pt" width="400.000000pt" version="1.0">
                <g stroke="none" fill="#00413E" transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)">
                  <path d="M1765 2911 c-117 -19 -232 -68 -327 -137 -87 -65 -210 -207 -308 -359 -214 -330 -250 -359 -512 -409 -65 -13 -124 -29 -133 -36 -19 -16 -19 -54 0 -70 33 -27 266 17 385 73 93 43 174 130 312 337 164 247 254 345 385 421 166 96 378 103 550 19 102 -50 194 -159 228 -268 6 -22 5 -23 -32 -15 -21 4 -74 8 -118 8 -69 0 -87 -4 -133 -30 -60 -32 -107 -90 -123 -150 -17 -63 -6 -166 25 -229 54 -109 140 -152 290 -143 175 10 334 86 533 254 45 38 104 81 131 96 69 37 164 60 215 52 47 -8 97 -31 97 -44 0 -5 -18 -24 -41 -41 -159 -126 -120 -351 71 -407 95 -28 257 -2 379 61 27 15 32 22 29 48 -5 53 -26 56 -132 20 -169 -57 -287 -36 -326 59 -10 24 -10 37 4 74 21 54 62 91 119 106 84 22 90 57 20 127 -151 151 -371 133 -593 -48 -229 -187 -378 -259 -533 -260 -112 0 -187 81 -187 202 0 66 25 110 79 138 55 28 121 26 214 -7 l79 -28 19 24 c36 44 16 187 -38 281 -47 80 -152 174 -245 218 -46 22 -103 45 -128 50 -65 16 -197 22 -255 13z"/>
                  <path d="M1115 1635 c-155 -85 -319 -102 -508 -51 -85 23 -102 25 -125 14 -37 -18 -42 -61 -10 -81 13 -9 64 -25 113 -38 178 -45 393 -25 545 50 74 37 88 38 143 10 219 -112 478 -114 712 -5 l70 32 88 -39 c223 -98 452 -99 666 -1 41 19 79 34 86 34 7 0 41 -13 76 -30 162 -76 374 -95 554 -51 110 27 135 42 135 81 0 49 -26 54 -127 24 -71 -22 -110 -27 -203 -28 -134 -1 -218 20 -337 85 -40 21 -79 39 -87 39 -9 0 -38 -14 -65 -30 -66 -41 -176 -77 -277 -92 -143 -21 -300 13 -437 94 -26 15 -55 28 -63 28 -9 0 -44 -16 -78 -35 -221 -123 -498 -122 -702 4 -28 17 -60 31 -70 30 -10 0 -55 -20 -99 -44z"/>
                  <path d="M1103 1265 c-163 -85 -342 -103 -517 -51 -98 29 -123 27 -132 -11 -10 -40 7 -56 85 -80 205 -64 428 -46 618 51 l53 26 60 -30 c32 -16 99 -42 147 -56 75 -23 107 -27 213 -27 142 0 223 17 350 75 l74 34 86 -37 c136 -58 208 -73 345 -72 130 1 243 26 345 78 61 31 69 31 128 1 171 -86 422 -104 608 -43 74 24 90 41 80 80 -9 38 -34 40 -132 11 -72 -21 -111 -27 -199 -28 -129 -1 -215 21 -332 85 -40 21 -79 39 -86 39 -8 0 -52 -20 -99 -45 -210 -112 -477 -108 -673 10 -32 19 -66 35 -75 35 -10 0 -45 -15 -77 -34 -207 -123 -469 -123 -690 -1 -35 19 -71 35 -81 34 -9 0 -54 -20 -99 -44z"/>
                </g>
              </svg>
              <p>Water Cleaned:<br/> <span id="water-cleaned">0</span> gallons</p>
            </div>
            <div class="impact-content">
              <svg style="width:50px; height:50px;" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" viewBox="0 0 400.000000 400.000000" height="400.000000pt" width="400.000000pt" version="1.0">
                <g stroke="none" fill="#00413E" transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)">
                  <path d="M1755 3516 c-470 -78 -856 -347 -1093 -763 -134 -235 -196 -473 -196 -753 1 -416 157 -786 458 -1085 224 -223 471 -357 776 -422 122 -26 478 -26 600 0 205 44 417 136 583 254 129 91 300 268 390 403 178 268 260 532 261 840 0 435 -172 839 -483 1132 -201 189 -450 318 -736 380 -117 26 -441 34 -560 14z m494 -102 c123 -21 255 -64 259 -85 4 -24 -44 -40 -151 -48 -73 -6 -105 -13 -125 -28 -30 -22 -111 -175 -112 -211 0 -59 113 -109 224 -99 217 21 202 21 362 -17 173 -41 237 -45 294 -16 58 29 93 26 130 -12 44 -46 83 -115 76 -134 -3 -8 -27 -24 -53 -36 -113 -50 -208 -59 -334 -33 -88 19 -124 40 -168 99 -51 67 -77 76 -226 76 -71 0 -146 -5 -168 -12 -48 -14 -148 -103 -171 -152 -20 -43 -21 -128 -1 -254 29 -181 29 -181 247 -271 159 -66 188 -71 304 -49 54 10 69 9 108 -6 59 -23 77 -53 87 -150 12 -108 20 -130 96 -275 89 -172 102 -209 113 -322 10 -99 24 -143 55 -169 9 -7 23 -26 31 -42 13 -25 13 -32 -2 -63 -24 -50 -166 -190 -268 -262 -174 -124 -405 -223 -606 -259 -140 -26 -373 -23 -510 5 -453 95 -831 377 -1034 770 -60 115 -91 198 -124 331 -24 95 -26 123 -27 295 0 180 5 225 36 348 5 20 16 37 23 37 8 0 28 -24 44 -54 25 -44 48 -65 135 -124 58 -39 107 -79 111 -88 3 -9 -3 -37 -15 -62 -44 -100 -32 -204 40 -337 44 -82 79 -110 163 -126 77 -15 119 -44 131 -89 5 -19 7 -90 4 -157 -8 -180 4 -271 52 -395 28 -71 51 -114 73 -135 64 -61 170 -85 208 -47 17 16 21 38 26 119 4 60 13 111 22 126 8 15 43 48 77 75 81 64 94 83 106 155 13 83 26 105 119 203 85 91 97 116 121 258 13 82 8 123 -19 137 -10 5 -50 14 -90 19 -87 13 -115 28 -150 89 -49 82 -94 135 -128 149 -22 9 -73 14 -155 14 -156 0 -175 9 -231 102 -23 39 -52 75 -65 81 -24 11 -30 9 -95 -18 -14 -6 -22 3 -39 41 -11 27 -29 58 -39 69 -30 31 -49 87 -39 112 12 31 35 41 146 58 142 23 193 40 291 97 132 78 149 94 228 214 70 106 77 113 143 148 99 52 141 112 141 202 0 39 -4 47 -32 64 -17 10 -63 24 -102 30 -117 19 -176 33 -194 47 -16 12 -16 14 0 27 22 16 145 43 253 56 102 11 273 4 394 -16z m-725 -128 c40 -22 91 -40 146 -51 47 -9 95 -18 107 -21 12 -2 28 -11 37 -19 26 -26 1 -60 -68 -93 -70 -34 -113 -78 -155 -160 -59 -114 -120 -171 -263 -243 -78 -39 -86 -41 -337 -80 -103 -16 -121 -35 -121 -129 0 -81 13 -117 64 -184 38 -51 44 -77 22 -95 -10 -9 -29 -1 -82 35 -105 71 -120 89 -154 181 -40 111 -39 154 5 239 114 218 297 425 480 542 72 47 209 112 234 112 13 0 52 -15 85 -34z m1181 -30 c45 -19 221 -145 260 -185 33 -35 29 -55 -16 -78 -39 -20 -79 -15 -271 34 l-182 46 -90 -22 c-104 -25 -116 -25 -151 -9 -31 14 -33 48 -5 94 25 40 32 42 138 48 70 4 96 11 170 45 98 46 100 46 147 27z m-177 -490 c13 -7 40 -34 60 -61 20 -27 51 -57 67 -66 17 -9 90 -27 163 -39 148 -25 195 -21 321 26 123 46 147 33 201 -107 93 -242 121 -541 73 -793 -30 -162 -105 -347 -182 -454 -28 -37 -34 -41 -52 -31 -30 15 -45 62 -52 154 -8 100 -27 157 -111 319 -78 153 -96 207 -96 298 0 91 -17 126 -80 173 -85 63 -116 69 -234 49 l-101 -17 -70 28 c-185 74 -215 91 -234 137 -10 24 -24 89 -31 144 -13 99 -12 103 10 148 24 51 77 93 132 106 43 11 186 1 216 -14z m-1324 -656 c47 -86 57 -90 220 -90 172 0 196 -9 243 -90 92 -160 99 -167 184 -177 76 -8 83 -16 75 -85 -8 -79 -32 -121 -116 -203 -83 -81 -110 -127 -110 -187 0 -58 -25 -95 -110 -163 -82 -66 -100 -98 -100 -183 0 -150 -83 -99 -135 84 -14 46 -19 114 -22 314 -5 280 -7 291 -66 315 -18 7 -54 16 -82 20 -109 15 -153 53 -195 164 -23 60 -25 119 -6 164 18 43 160 179 179 171 8 -3 26 -27 41 -54z"/>
                </g>
              </svg>
              <p>CO2 Captured:<br/> <span id="co2-captured">0</span> grams</p>
            </div>
            <div class="impact-content">
              <svg style="width:50px; height:50px;" xmlns="http://www.w3.org/2000/svg" version="1.0" width="500.000000pt" height="500.000000pt" viewBox="0 0 500.000000 500.000000" preserveAspectRatio="xMidYMid meet">
                <g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)" fill="#00413E" stroke="none">
                  <path d="M1220 4122 c-240 -160 -320 -228 -320 -268 0 -13 24 -57 53 -98 28 -42 77 -111 107 -155 32 -46 63 -81 75 -83 10 -2 30 -19 43 -38 21 -30 23 -43 19 -95 -3 -33 -22 -112 -41 -175 -71 -226 -49 -329 118 -560 42 -58 85 -116 94 -129 16 -22 20 -23 42 -11 32 16 70 51 70 63 0 5 -39 62 -86 126 -48 64 -101 145 -118 181 -44 91 -43 185 3 323 60 181 60 255 2 349 -18 28 -30 52 -29 53 30 22 276 189 283 192 6 2 23 -12 37 -32 61 -87 128 -111 344 -124 175 -10 233 -31 302 -105 75 -82 78 -74 -60 -169 -68 -46 -210 -142 -315 -212 -106 -71 -193 -131 -193 -135 0 -17 322 -476 381 -544 4 -4 149 82 322 193 173 111 319 201 324 201 10 0 87 -102 137 -180 37 -59 225 -318 234 -324 4 -2 28 11 54 28 l47 32 -429 610 c-464 660 -468 665 -585 699 -27 9 -122 20 -210 26 -104 7 -172 16 -193 26 -37 18 -74 64 -78 98 -2 21 -176 286 -210 320 -33 33 -74 18 -224 -83z m218 -124 l51 -76 -155 -107 c-85 -58 -161 -108 -169 -111 -11 -5 -99 96 -107 123 -3 9 322 257 327 250 1 -1 25 -36 53 -79z m975 -730 c93 -126 187 -265 187 -276 0 -7 -429 -297 -525 -354 -8 -5 -56 55 -140 174 -97 137 -124 183 -114 189 8 4 129 82 269 173 140 90 258 165 262 165 5 1 32 -32 61 -71z"/>
                  <path d="M653 2389 c-73 -9 -163 -50 -215 -100 -42 -40 -49 -76 -20 -102 29 -26 65 -20 115 18 50 38 77 50 143 65 75 17 133 -3 257 -87 157 -108 182 -118 297 -117 115 0 161 18 292 117 100 75 134 89 218 88 75 0 125 -22 233 -100 124 -90 164 -105 272 -105 113 0 160 18 289 108 112 78 157 96 238 96 75 0 111 -16 218 -95 127 -95 165 -109 280 -110 83 0 103 4 154 28 32 15 89 49 126 77 100 74 162 100 240 100 79 0 122 -19 210 -90 156 -127 322 -151 485 -71 110 54 154 122 107 164 -26 24 -56 21 -90 -8 -55 -46 -141 -79 -207 -79 -74 1 -126 23 -220 94 -134 102 -238 133 -365 110 -80 -14 -102 -26 -219 -111 -175 -129 -287 -129 -436 1 -74 65 -141 97 -228 109 -132 19 -239 -14 -357 -109 -81 -65 -106 -78 -176 -91 -89 -17 -139 1 -253 86 -109 82 -149 102 -235 114 -129 18 -261 -23 -365 -113 -65 -57 -95 -73 -160 -87 -96 -20 -159 4 -304 119 -89 70 -193 96 -324 81z"/>
                  <path d="M1722 2130 c-23 -17 -42 -36 -42 -43 0 -24 838 -1197 877 -1229 94 -76 225 -106 318 -74 26 8 92 46 147 82 90 59 105 74 149 144 54 85 62 90 177 116 64 14 86 25 171 89 149 111 185 168 184 295 0 110 -50 223 -163 369 l-46 60 -47 -31 c-26 -17 -47 -35 -47 -40 0 -5 29 -49 64 -98 102 -142 129 -215 112 -305 -16 -83 -166 -196 -311 -234 -80 -21 -95 -29 -135 -70 -25 -25 -66 -73 -91 -106 -81 -108 -215 -178 -297 -155 -100 26 -110 39 -547 658 -225 320 -415 586 -421 592 -7 7 -23 1 -52 -20z"/>
                  <path d="M587 1910 c-102 -36 -187 -105 -187 -151 0 -24 34 -59 58 -59 10 0 42 18 71 40 67 51 146 75 218 66 72 -8 128 -36 204 -101 78 -68 148 -96 255 -103 127 -7 245 36 314 114 32 37 36 54 20 85 -17 31 -70 25 -131 -18 -95 -65 -195 -80 -279 -42 -25 11 -82 47 -127 80 -118 85 -160 102 -268 106 -72 3 -102 -1 -148 -17z"/>
                  <path d="M3748 1913 c-25 -28 -23 -69 5 -87 12 -8 44 -20 70 -26 73 -16 105 -32 182 -90 118 -89 161 -105 291 -105 107 0 112 1 186 38 86 42 128 84 128 127 0 28 -30 60 -55 60 -6 0 -42 -20 -79 -45 -147 -96 -233 -88 -416 40 -110 77 -156 97 -230 103 -55 4 -68 1 -82 -15z"/>
                  <path d="M2237 1817 l-38 -33 188 -271 c103 -150 192 -272 197 -273 5 0 29 12 53 28 29 18 42 32 40 44 -9 34 -370 538 -386 538 -9 -1 -33 -15 -54 -33z"/>
                  <path d="M638 1460 c-101 -18 -219 -92 -232 -146 -5 -17 -1 -35 9 -50 23 -36 62 -31 125 16 65 48 109 64 180 64 69 0 124 -24 233 -102 45 -33 96 -67 114 -76 50 -25 161 -38 230 -27 74 12 105 26 208 101 95 68 127 85 187 100 69 18 143 -1 222 -56 70 -48 104 -54 129 -26 27 30 20 62 -21 101 -78 74 -218 120 -326 107 -65 -9 -155 -50 -240 -110 -94 -67 -161 -96 -227 -96 -81 0 -134 22 -224 95 -112 92 -239 128 -367 105z"/>
                  <path d="M3997 1342 c-43 -47 8 -117 122 -171 51 -24 67 -26 176 -26 101 1 129 5 179 24 108 43 167 130 118 174 -27 25 -54 21 -102 -14 -71 -52 -118 -69 -193 -69 -76 0 -111 12 -187 64 -58 40 -89 45 -113 18z"/>
                </g>
              </svg>
              <p>Ocean Plastic<br/> Removed:<br/> <span id="plastic-removed">0</span> lb</p>
            </div>
          </div>
        `;

        var existingImpactInfo = drawerHeader.querySelector('.impact-info');

        if (existingImpactInfo) {
          existingImpactInfo.replaceWith(impactInfo);
        } else {
          drawerHeader.prepend(impactInfo);
        }

        // Animate the values
        animateValue(document.getElementById('water-cleaned'), 0, totalWaterCleaned, 1000);
        animateValue(document.getElementById('co2-captured'), 0, totalCo2Captured, 1000);
        animateValue(document.getElementById('plastic-removed'), 0, 1, 1000);

      }
    } else {
      var drawerHeader = document.querySelector('.qsc2-drawer-footer');
      var existingImpactInfo = drawerHeader ? drawerHeader.querySelector('.impact-info') : null;

      if (existingImpactInfo) {
        existingImpactInfo.remove();
      }
    }
  }

  // Function to fetch and process the cart contents
  function fetchCartContents() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateEnvironmentalImpact(cart.items);
      })
      .catch(error => {
        console.error("Error fetching cart contents:", error);
      });
  }

  // Safely add event listeners
  function setupEventListeners() {
    var addToCartButton = document.querySelector('[name="add"]');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', function(event) {
        setTimeout(fetchCartContents, 1000);
      });
    }

    document.addEventListener('click', function(event) {
      if (event.target.matches('.qsc2-product-item__quantity-btn')) {
        setTimeout(fetchCartContents, 1000);
      }
    });

    document.addEventListener('change', function(event) {
      if (event.target.matches('.qsc2-basic.qsc2-product-item__quantity-input')) {
        setTimeout(fetchCartContents, 1000);
      }
    });

    document.addEventListener('click', function(event) {
      if (event.target.closest('.qsc2-basic.qsc2-btn.qsc2-sf-content__action-btn')) {
        setTimeout(fetchCartContents, 1000);
      }
    });

    // Animate impact when cart button is clicked and cart is opened
    var cartButton = document.querySelector('a.site-nav__link.site-nav__link--icon.site-nav__link--cart');
    if (cartButton) {
      cartButton.addEventListener('click', function() {
        setTimeout(function() {
          var waterElement = document.getElementById('water-cleaned');
          var co2Element = document.getElementById('co2-captured');
          var plastic = document.getElementById('plastic-removed');
          if (waterElement && co2Element) {
            animateValue(waterElement, 0, parseFloat(waterElement.innerText), 1000);
            animateValue(co2Element, 0, parseFloat(co2Element.innerText), 1000);
            animateValue(plastic, 0, parseFloat(plastic.innerText), 1000);
            
          }
        }, 500); // Delay to ensure cart is fully opened and content is rendered
      });
    }
  }

  fetchCartContents();
  setupEventListeners();
});
